import { createSelector } from '@reduxjs/toolkit';
import { AllowedSettings } from 'utils/globalSettings';
import { selectglobalSettings } from './selectors';

export const selectGlobalDbSetting_EnableLegacyScheduler = createSelector(
  [selectglobalSettings],
  state =>
    state.GetBooleanByKey(AllowedSettings.EnableLegacyScheduler) ?? false,
);
